
import {
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    TOKEN_LOGIN, SET_SITE
} from '../types/login';


export const login = () => {

    return dispatch => {
        dispatch({
            type: LOGIN,
        });
    }
};

export const loginResponse = (response) => {

    return dispatch => {
        dispatch({
            type: response.status? LOGIN_SUCCESS: LOGIN_FAIL,
            response
        })
    }
};

export const loginTokenResponse = (response) => {

    return dispatch => {
        dispatch({
            type: TOKEN_LOGIN,
            response
        })
    }
};

export const setCurrentSite = (data) => {
    return dispatch => {
        dispatch({
            type: SET_SITE,
            data
        })
    }
};



// WEBPACK FOOTER //
// ./src/actions/login.js